
import { IPaymentBillPageParams, IPaymentReceiptPageParams } from '../types/lianlian-manage';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 连连账户 - 交易流水分页查询
 */

export async function queryLianlianFundPageList(params) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/agent/fund/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 *  空中分账 - 分账账户 - 连连管理交易记录分页导出
 */

export async function exportLianlianFundPage(params) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/agent/fund/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 连连账户 - 回单下载分页查询
 */

export async function queryLianlianReceiptPageList(params) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/agent/receipt/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 *  空中分账 - 连连账户 - 连连管理回单分页导出
 */

export async function exportLianlianReceiptPage(params: IPaymentReceiptPageParams) {
  let data = '' as string | null;

  try {
    const { code, context, message } = await Http[__ENABLE_DEV_MOCK__ || __MOCK_PROD__ ? 'get' : 'post']<any>(
      `${hostUrl}/pay/agent/receipt/batch-download`,
      { ...params },
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账账户 - 连连管理提现记录
 */
export async function queryLianlianCashPageList(page: number, size: number, lianId: string) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/agent/cash/page`, {
      page,
      size,
      lianId,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账账户 - 连连管理对账单
 */
export async function queryLianlianBillPageList(params?: IPaymentBillPageParams) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/agent/bill/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账账户 - 连连管理对账单导出
 */

export async function exportLianlianBillPage(params?: IPaymentBillPageParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/agent/bill/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}
